// extracted by mini-css-extract-plugin
module.exports = {"seo-preview":"SERPPreview_seo-preview__Y12iv","url":"SERPPreview_url__OVuKY","title":"SERPPreview_title__i7X30","description":"SERPPreview_description__4ABTn"};